import { getGeoData } from "src/integrations/lib/geoData"
import { buildPlainUserData } from "src/integrations/lib/mapping"
import { getUserId } from "src/tracking/state"
import { checkoutContactStore } from "../../checkout/state/checkoutContactStore"
import { googleUpdateUserData } from "../google/userData"
import { klaviyoUpdateUserData } from "../klaviyo/userData"

export async function updateUserData() {
  const userId = getUserId()
  const geoData = await getGeoData()
  const contactData = checkoutContactStore.getState()
  const plainUserData = buildPlainUserData(userId, geoData, contactData)

  googleUpdateUserData(plainUserData)
  // metaUpdateUserData(plainUserData)
  klaviyoUpdateUserData(plainUserData)
}
